import React from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Login from "./Login";
import Sub from "./Pages/Sub";
import Queue from "./Pages/Queue";
import Dashboard from "./Pages/Dashboard";
import Category from "./Pages/Category";
import "./App.css";
import MainHeader from "./Pages/MainHeader";

// ✅ Private Route to Protect Pages
const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = localStorage.getItem("token"); // Check if user is logged in

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          {/* Public Route (Login) */}
          <Route exact path="/" component={Login} />

          {/* Protected Routes (Require Login) */}
          <PrivateRoute path="/Dashboard" component={Dashboard} />
          <PrivateRoute path="/Category" component={Category} />
          <PrivateRoute path="/Sub" component={Sub} />
          <PrivateRoute path="/Queue" component={Queue} />

          {/* Redirect unknown routes to Login */}
          <Route path="*">
            <Redirect to="/" />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
